import { useState, useEffect } from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import "./BannerCarousel.css";
import { PATH_GALERIA_PRODUCTION } from "../../../const/PATH";
import CardPlaceholder from "../load/CardPlaceholder";

const BannerCarousel = ({ banners, className = "" }) => {
  const [visibleBanners, setVisibleBanners] = useState([]);

  useEffect(() => {
    console.log("BannerCarousel - banners recibidos:", banners);

    if (!banners || !Array.isArray(banners)) {
      console.log("BannerCarousel - No hay banners o no es array");
      setVisibleBanners([]);
      return;
    }

    const now = new Date();
    const filtered = banners.filter((banner) => {
      // Primero verificar que el banner esté ACTIVO
      if (banner.stated !== "ACTIVO") {
        console.log(`Banner ${banner.nombre}: estado=${banner.stated}, NO visible`);
        return false;
      }

      // Si está activo pero no tiene vigencia, es visible
      if (!banner.vigencia) {
        console.log(`Banner ${banner.nombre}: ACTIVO sin vigencia, VISIBLE`);
        return true;
      }

      try {
        const fechas = JSON.parse(banner.vigencia);

        // Si la fecha de inicio está vacía o no existe, mostrar el banner (ya que está ACTIVO)
        if (!fechas[0] || fechas[0] === "") {
          console.log(`Banner ${banner.nombre}: ACTIVO sin fecha de inicio, VISIBLE`);
          return true;
        }

        const fechaInicio = new Date(fechas[0]);

        // Verificar que la fecha de inicio sea válida
        if (isNaN(fechaInicio.getTime())) {
          console.log(`Banner ${banner.nombre}: ACTIVO con fecha de inicio inválida, VISIBLE`);
          return true;
        }

        // Solo verificar que la fecha de inicio haya pasado (no verificamos fecha fin)
        const yaInicio = fechaInicio <= now;
        console.log(`Banner ${banner.nombre}: ACTIVO, inicio=${fechas[0]}, ya inició=${yaInicio}`);
        return yaInicio;
      } catch (error) {
        console.error("Error parsing banner vigencia:", error, banner);
        // En caso de error, si está ACTIVO, mostrarlo
        return true;
      }
    });

    console.log("BannerCarousel - Banners visibles:", filtered.length);
    setVisibleBanners(filtered);
  }, [banners]);

  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 1,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 1,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 1,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };

  const CustomDot = ({ onClick, active }) => {
    return (
      <button
        className={`custom-dot ${active ? "active" : ""}`}
        onClick={onClick}
        aria-label="Banner navigation dot"
      >
        <span></span>
      </button>
    );
  };

  // Mostrar placeholder mientras carga
  if (!banners) {
    return (
      <div
        className={`banner-carousel-container ${className}`}
        style={{
          height: "400px",
          borderRadius: "20px",
          overflow: "hidden",
        }}
      >
        <CardPlaceholder width="100%" height="400px" />
      </div>
    );
  }

  // Si no hay banners visibles después del filtrado, no mostrar nada
  // (esto solo ocurriría si banners.length === 0)
  if (visibleBanners.length === 0) {
    console.log("BannerCarousel - No hay banners para mostrar");
    return null;
  }

  return (
    <div className={`banner-carousel-container ${className}`}>
      <Carousel
        responsive={responsive}
        infinite={visibleBanners.length > 1}
        autoPlay={visibleBanners.length > 1}
        autoPlaySpeed={5000}
        transitionDuration={800}
        removeArrowOnDeviceType={["tablet", "mobile"]}
        showDots={visibleBanners.length > 1}
        customDot={<CustomDot />}
        renderDotsOutside={true}
        arrows={visibleBanners.length > 1}
        containerClass="banner-carousel"
        itemClass="banner-carousel-item"
      >
        {visibleBanners.map((banner, index) => {
          const imageUrl = banner.imagen?.startsWith("https")
            ? banner.imagen
            : `${PATH_GALERIA_PRODUCTION}${banner.imagen}`;

          return (
            <div key={index} className="banner-slide">
              {banner.url ? (
                <a
                  href={banner.url}
                  className="banner-link"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <div className="banner-image-wrapper">
                    <img
                      src={imageUrl}
                      alt={banner.nombre || `Banner ${index + 1}`}
                      className="banner-image"
                      loading={index === 0 ? "eager" : "lazy"}
                    />
                    <div className="banner-overlay"></div>
                  </div>
                </a>
              ) : (
                <div className="banner-image-wrapper">
                  <img
                    src={imageUrl}
                    alt={banner.nombre || `Banner ${index + 1}`}
                    className="banner-image"
                    loading={index === 0 ? "eager" : "lazy"}
                  />
                  <div className="banner-overlay"></div>
                </div>
              )}
            </div>
          );
        })}
      </Carousel>
    </div>
  );
};

export default BannerCarousel;
